import { createContext } from 'react';
import type RoutesPlannerStore from '../../stores/routes-planner-store';

export const StoreContext = createContext<RoutesPlannerStore>(undefined as unknown as RoutesPlannerStore);
export const StoreProvider = StoreContext.Provider;
